// localStorage 관련 헬퍼 함수들

/**
 * 캐스팅 매니저의 다이어리 노출 정보를 localStorage에 저장
 * @param diaryId 저장할 다이어리 ID
 */
export const saveDiaryViewToLocalStorage = (diaryId: number) => {
    try {
        const key = 'agencyDiaryListView';
        const now = new Date();
        // %Y-%m-%d h:i 형식으로 키 생성 (초 단위 제거)
        const dateKey = now.toISOString().slice(0, 16).replace('T', ' '); // YYYY-MM-DD HH:mm 형식
        
        // 기존 데이터 가져오기
        const existingData = localStorage.getItem(key);
        let viewData: Record<string, number[]> = {};
        
        if (existingData) {
            try {
                viewData = JSON.parse(existingData);
            } catch (e) {
                console.warn('기존 localStorage 데이터 파싱 실패, 새로 시작합니다.');
                viewData = {};
            }
        }
        
        // 현재 날짜/시간에 다이어리 ID 추가
        if (!viewData[dateKey]) {
            viewData[dateKey] = [];
        }
        
        // 중복 방지
        if (!viewData[dateKey].includes(diaryId)) {
            viewData[dateKey].push(diaryId);
        }
        
        // localStorage에 저장
        localStorage.setItem(key, JSON.stringify(viewData));
        
        console.log('📱 다이어리 노출 정보 저장 완료:', {
            dateKey,
            diaryId,
            totalViews: viewData[dateKey].length
        });
        
    } catch (error) {
        console.error('localStorage 저장 실패:', error);
    }
};

/**
 * localStorage에서 특정 키의 데이터를 가져오는 헬퍼 함수
 * @param key localStorage 키
 * @param defaultValue 기본값
 * @returns 파싱된 데이터 또는 기본값
 */
export const getLocalStorageData = <T>(key: string, defaultValue: T): T => {
    try {
        const data = localStorage.getItem(key);
        if (data === null) {
            return defaultValue;
        }
        return JSON.parse(data);
    } catch (error) {
        console.warn(`localStorage 데이터 파싱 실패 (${key}):`, error);
        return defaultValue;
    }
};

/**
 * localStorage에 데이터를 저장하는 헬퍼 함수
 * @param key localStorage 키
 * @param data 저장할 데이터
 */
export const setLocalStorageData = <T>(key: string, data: T): void => {
    try {
        localStorage.setItem(key, JSON.stringify(data));
    } catch (error) {
        console.error(`localStorage 데이터 저장 실패 (${key}):`, error);
    }
};

/**
 * localStorage에서 특정 키의 데이터를 삭제하는 헬퍼 함수
 * @param key localStorage 키
 */
export const removeLocalStorageData = (key: string): void => {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        console.error(`localStorage 데이터 삭제 실패 (${key}):`, error);
    }
};

/**
 * 캐스팅 매니저의 다이어리 뷰 정보를 localStorage에서 삭제
 */
export const removeDiaryViewData = (): void => {
    try {
        const key = 'agencyDiaryListView';
        localStorage.removeItem(key);
        console.log('🗑️ 다이어리 뷰 정보 삭제 완료');
    } catch (error) {
        console.error('다이어리 뷰 정보 삭제 실패:', error);
    }
};
